<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      <span class="ml-25" target="_blank"
        >مؤسسة الصدى لتقنية المعلومات، مؤسسة سعودية رسمية ومسجلة في وزارة التجارة برقم / 1128183340</span
      >
    </span>
  </p>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
  components: {
    BLink,
  },
};
</script>
